import { createReducer } from 'redux-act';
import actions from '../actions/travelAndClaimAction';

const initialState = {
  createTravelApplicationPending: false,
  createTravelApplicationRes: null,
  createTravelApplicationError: null,

  getTravelRequestPending: false,
  getTravelRequestRes: null,
  getTravelRequestError: null,

  getTravelApprovalPending: false,
  getTravelApprovalRes: null,
  getTravelApprovalError: null,

  updateTravelApplicationPending: false,
  updateTravelApplicationRes: null,
  updateTravelApplicationError: null,

  deleteTravelPending: false,
  deleteTravelRes: null,
  deleteTravelError: null,

  addTravelTypePending: false,
  addTravelTypeRes: null,
  addTravelTypeError: null,

  getTravelTypePending: false,
  getTravelTypeRes: null,
  getTravelTypeError: null,

  updateTravelTypePending: false,
  updateTravelTypeRes: null,
  updateTravelTypeError: null,

  deleteTravelTypePending: false,
  deleteTravelTypeRes: null,
  deleteTravelTypeError: null,

  getAllTravelTypePending: false,
  getAllTravelTypeRes: null,
  getAllTravelTypeError: null,

  travelRequestApproveRejectPending: false,
  travelRequestApproveRejectRes: null,
  travelRequestApproveRejectError: null,

  createTravelAndClaimRulePending: false,
  createTravelAndClaimRuleRes: null,
  createTravelAndClaimRuleError: null,

  getTravelAndClaimRulePending: false,
  getTravelAndClaimRuleRes: null,
  getTravelAndClaimRuleError: null,

  updateTravelAndClaimRulePending: false,
  updateTravelAndClaimRuleRes: null,
  updateTravelAndClaimRuleError: null,

  deleteTravelAndClaimRulePending: false,
  deleteTravelAndClaimRuleRes: null,
  deleteTravelAndClaimRuleError: null,

  getAllTravelAndClaimRulePending: false,
  getAllTravelAndClaimRuleRes: null,
  getAllTravelAndClaimRuleError: null,

  assignRulePending: false,
  assignRuleRes: null,
  assignRuleError: null,

  getAssignRulePending: false,
  getAssignRuleRes: null,
  getAssignRuleError: null,

  getTravelTypeByIdPending: false,
  getTravelTypeByIdRes: null,
  getTravelTypeByIdError: null,


  createClaimPending: false,
  createClaimRes: null,
  createClaimError: null,

  updateClaimPending: false,
  updateClaimRes: null,
  updateClaimError: null,

  deleteClaimPending: false,
  deleteClaimRes: null,
  deleteClaimError: null,

  getClaimPending: false,
  getClaimRes: null,
  getClaimError: null,

  getClaimApprovalPending: false,
  getClaimApprovalRes: null,
  getClaimApprovalError: null,

  approveRejectClaimPending: false,
  approveRejectClaimRes: null,
  approveRejectClaimError: null,

  getAllTravelApprovalDataPending: false,
  getAllTravelApprovalDataRes: null,
  getAllTravelApprovalDataError: null,

  selectedTravelData:null,

  selectedTravelClaimDetail :null
};
/* Create Travel Application Reducers */
const handleCreateTravelApplicationRequest = state => {
  return {
    ...state,
    ...{
      createTravelApplicationPending: true,
      createTravelApplicationRes: null,
      createTravelApplicationError: null,
    },
  };
};
const handleCreateTravelApplicationSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      createTravelApplicationPending: false,
      createTravelApplicationRes: payload,
      createTravelApplicationError: null,
    },
  };
};
const handleCreateTravelApplicationError = (state, payload) => ({
  ...state,
  ...{
    createTravelApplicationPending: false,
    createTravelApplicationRes: null,
    createTravelApplicationError: payload,
  },
});


/* Get Travel RequestReducers */
const handleGetTravelRequestRequest = state1 => {
  return {
    ...state1,
    ...{
      getTravelRequestPending: true,
      getTravelRequestRes: null,
      getTravelRequestError: null,
    },
  };
};
const handleGetTravelRequestSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getTravelRequestPending: false,
      getTravelRequestRes: payload,
      getTravelRequestError: null,
    },
  };
};
const handleGetTravelRequestError = (state1, payload) => ({
  ...state1,
  ...{
    getTravelRequestPending: false,
    getTravelRequestRes: null,
    getTravelRequestError: payload,
  },
});

/* Get Travel Approval Reducers */
const handleGetTravelApprovalRequest = state1 => {
  return {
    ...state1,
    ...{
      getTravelApprovalPending: true,
      getTravelApprovalRes: null,
      getTravelApprovalError: null,
    },
  };
};
const handleGetTravelApprovalSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getTravelApprovalPending: false,
      getTravelApprovalRes: payload,
      getTravelApprovalError: null,
    },
  };
};
const handleGetTravelApprovalError = (state1, payload) => ({
  ...state1,
  ...{
    getTravelApprovalPending: false,
    getTravelApprovalRes: null,
    getTravelApprovalError: payload,
  },
});

/* Update Travel Application Reducers */
const handleUpdateTravelApplicationRequest = state1 => {
  return {
    ...state1,
    ...{
      updateTravelApplicationPending: true,
      updateTravelApplicationRes: null,
      updateTravelApplicationError: null,
    },
  };
};
const handleUpdateTravelApplicationSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateTravelApplicationPending: false,
      updateTravelApplicationRes: payload,
      updateTravelApplicationError: null,
    },
  };
};
const handleUpdateTravelApplicationError = (state1, payload) => ({
  ...state1,
  ...{
    updateTravelApplicationPending: false,
    updateTravelApplicationRes: null,
    updateTravelApplicationError: payload,
  },
});

/* Delete Travel Reducers*/
const handleDeleteTravelRequest = state1 => {
  return {
    ...state1,
    ...{
      deleteTravelPending: true,
      deleteTravelRes: null,
      deleteTravelError: null,
    },
  };
};
const handleDeleteTravelSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      deleteTravelPending: false,
      deleteTravelRes: payload,
      deleteTravelError: null,
    },
  };
};
const handleDeleteTravelError = (state1, payload) => ({
  ...state1,
  ...{
    deleteTravelPending: false,
    deleteTravelRes: null,
    deleteTravelError: payload,
  },
});

/* Add Travel Reducers*/
const handleAddTravelTypeRequest = state1 => {
  return {
    ...state1,
    ...{
      addTravelTypePending: true,
      addTravelTypeRes: null,
      addTravelTypeError: null,
    },
  };
};
const handleAddTravelTypeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      addTravelTypePending: false,
      addTravelTypeRes: payload,
      addTravelTypeError: null,
    },
  };
};
const handleAddTravelTypeError = (state1, payload) => ({
  ...state1,
  ...{
    addTravelTypePending: false,
    addTravelTypeRes: null,
    addTravelTypeError: payload,
  },
});


/* Get Travel Reducers*/
const handleGetTravelTypeRequest = state1 => {
  return {
    ...state1,
    ...{
      getTravelTypePending: true,
      getTravelTypeRes: null,
      getTravelTypeError: null,
    },
  };
};
const handleGetTravelTypeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getTravelTypePending: false,
      getTravelTypeRes: payload,
      getTravelTypeError: null,
    },
  };
};
const handleGetTravelTypeError = (state1, payload) => ({
  ...state1,
  ...{
    getTravelTypePending: false,
    getTravelTypeRes: null,
    getTravelTypeError: payload,
  },
});

/* Update Travel Reducers*/
const handleUpdateTravelTypeRequest = state1 => {
  return {
    ...state1,
    ...{
      updateTravelTypePending: true,
      updateTravelTypeRes: null,
      updateTravelTypeError: null,
    },
  };
};
const handleUpdateTravelTypeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateTravelTypePending: false,
      updateTravelTypeRes: payload,
      updateTravelTypeError: null,
    },
  };
};
const handleUpdateTravelTypeError = (state1, payload) => ({
  ...state1,
  ...{
    updateTravelTypePending: false,
    updateTravelTypeRes: null,
    updateTravelTypeError: payload,
  },
});

/* Delete Travel Reducers*/
const handleDeleteTravelTypeRequest = state1 => {
  return {
    ...state1,
    ...{
      deleteTravelTypePending: true,
      deleteTravelTypeRes: null,
      deleteTravelTypeError: null,
    },
  };
};
const handleDeleteTravelTypeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      deleteTravelTypePending: false,
      deleteTravelTypeRes: payload,
      deleteTravelTypeError: null,
    },
  };
};
const handleDeleteTravelTypeError = (state1, payload) => ({
  ...state1,
  ...{
    deleteTravelTypePending: false,
    deleteTravelTypeRes: null,
    deleteTravelTypeError: payload,
  },
});

/* Get Travel Reducers*/
const handleGetAllTravelTypeRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllTravelTypePending: true,
      getAllTravelTypeRes: null,
      getAllTravelTypeError: null,
    },
  };
};
const handleGetAllTravelTypeSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllTravelTypePending: false,
      getAllTravelTypeRes: payload,
      getAllTravelTypeError: null,
    },
  };
};
const handleGetAllTravelTypeError = (state1, payload) => ({
  ...state1,
  ...{
    getAllTravelTypePending: false,
    getAllTravelTypeRes: null,
    getAllTravelTypeError: payload,
  },
});

/* Travel Request Approve Reject Reducers*/
const handleTravelRequestApproveRejectRequest = state1 => {
  return {
    ...state1,
    ...{
      travelRequestApproveRejectPending: true,
      travelRequestApproveRejectRes: null,
      travelRequestApproveRejectError: null,
    },
  };
};
const handleTravelRequestApproveRejectSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      travelRequestApproveRejectPending: false,
      travelRequestApproveRejectRes: payload,
      travelRequestApproveRejectError: null,
    },
  };
};
const handleTravelRequestApproveRejectError = (state1, payload) => ({
  ...state1,
  ...{
    travelRequestApproveRejectPending: false,
    travelRequestApproveRejectRes: null,
    travelRequestApproveRejectError: payload,
  },
});

/* Create Travel And Claim Rule Reducers*/
const handleCreateTravelAndClaimRuleRequest = state1 => {
  return {
    ...state1,
    ...{
      createTravelAndClaimRulePending: true,
      createTravelAndClaimRuleRes: null,
      createTravelAndClaimRuleError: null,
    },
  };
};
const handleCreateTravelAndClaimRuleSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      createTravelAndClaimRulePending: false,
      createTravelAndClaimRuleRes: payload,
      createTravelAndClaimRuleError: null,
    },
  };
};
const handleCreateTravelAndClaimRuleError = (state1, payload) => ({
  ...state1,
  ...{
    createTravelAndClaimRulePending: false,
    createTravelAndClaimRuleRes: null,
    createTravelAndClaimRuleError: payload,
  },
});

/* Get Travel And Claim Rule Reducers*/
const handleGetTravelAndClaimRuleRequest = state1 => {
  return {
    ...state1,
    ...{
      getTravelAndClaimRulePending: true,
      getTravelAndClaimRuleRes: null,
      getTravelAndClaimRuleError: null,
    },
  };
};
const handleGetTravelAndClaimRuleSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getTravelAndClaimRulePending: false,
      getTravelAndClaimRuleRes: payload,
      getTravelAndClaimRuleError: null,
    },
  };
};
const handleGetTravelAndClaimRuleError = (state1, payload) => ({
  ...state1,
  ...{
    getTravelAndClaimRulePending: false,
    getTravelAndClaimRuleRes: null,
    getTravelAndClaimRuleError: payload,
  },
});


/* Update Travel And Claim Rule Reducers*/
const handleUpdateTravelAndClaimRuleRequest = state1 => {
  return {
    ...state1,
    ...{
      updateTravelAndClaimRulePending: true,
      updateTravelAndClaimRuleRes: null,
      updateTravelAndClaimRuleError: null,
    },
  };
};
const handleUpdateTravelAndClaimRuleSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateTravelAndClaimRulePending: false,
      updateTravelAndClaimRuleRes: payload,
      updateTravelAndClaimRuleError: null,
    },
  };
};
const handleUpdateTravelAndClaimRuleError = (state1, payload) => ({
  ...state1,
  ...{
    updateTravelAndClaimRulePending: false,
    updateTravelAndClaimRuleRes: null,
    updateTravelAndClaimRuleError: payload,
  },
});

/* Delete Travel And Claim Rule Reducers*/
const handleDeleteTravelAndClaimRuleRequest = state1 => {
  return {
    ...state1,
    ...{
      deleteTravelAndClaimRulePending: true,
      deleteTravelAndClaimRuleRes: null,
      deleteTravelAndClaimRuleError: null,
    },
  };
};
const handleDeleteTravelAndClaimRuleSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      deleteTravelAndClaimRulePending: false,
      deleteTravelAndClaimRuleRes: payload,
      deleteTravelAndClaimRuleError: null,
    },
  };
};
const handleDeleteTravelAndClaimRuleError = (state1, payload) => ({
  ...state1,
  ...{
    deleteTravelAndClaimRulePending: false,
    deleteTravelAndClaimRuleRes: null,
    deleteTravelAndClaimRuleError: payload,
  },
});


/* GetAll Travel And Claim Rule Reducers*/
const handleGetAllTravelAndClaimRuleRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllTravelAndClaimRulePending: true,
      getAllTravelAndClaimRuleRes: null,
      getAllTravelAndClaimRuleError: null,
    },
  };
};
const handleGetAllTravelAndClaimRuleSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllTravelAndClaimRulePending: false,
      getAllTravelAndClaimRuleRes: payload,
      getAllTravelAndClaimRuleError: null,
    },
  };
};
const handleGetAllTravelAndClaimRuleError = (state1, payload) => ({
  ...state1,
  ...{
    getAllTravelAndClaimRulePending: false,
    getAllTravelAndClaimRuleRes: null,
    getAllTravelAndClaimRuleError: payload,
  },
});


/* Assign Rule Reducers*/
const handleAssignRuleRequest = state1 => {
  return {
    ...state1,
    ...{
      assignRulePending: true,
      assignRuleRes: null,
      assignRuleError: null,
    },
  };
};
const handleAssignRuleSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      assignRulePending: false,
      assignRuleRes: payload,
      assignRuleError: null,
    },
  };
};
const handleAssignRuleError = (state1, payload) => ({
  ...state1,
  ...{
    assignRulePending: false,
    assignRuleRes: null,
    assignRuleError: payload,
  },
});

/* Get Assign Rule Reducers*/
const handleGetAssignRuleRequest = state1 => {
  return {
    ...state1,
    ...{
      getAssignRulePending: true,
      getAssignRuleRes: null,
      getAssignRuleError: null,
    },
  };
};
const handleGetAssignRuleSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAssignRulePending: false,
      getAssignRuleRes: payload,
      getAssignRuleError: null,
    },
  };
};
const handleGetAssignRuleError = (state1, payload) => ({
  ...state1,
  ...{
    getAssignRulePending: false,
    getAssignRuleRes: null,
    getAssignRuleError: payload,
  },
});


/*Get Travel Type By Id Reducers*/
const handleGetTravelTypeByIdRequest = state1 => {
  return {
    ...state1,
    ...{
      getTravelTypeByIdPending: true,
      getTravelTypeByIdRes: null,
      getTravelTypeByIdError: null,
    },
  };
};
const handleGetTravelTypeByIdSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getTravelTypeByIdPending: false,
      getTravelTypeByIdRes: payload,
      getTravelTypeByIdError: null,
    },
  };
};
const handleGetTravelTypeByIdError = (state1, payload) => ({
  ...state1,
  ...{
    getTravelTypeByIdPending: false,
    getTravelTypeByIdRes: null,
    getTravelTypeByIdError: payload,
  },
});


/*create Claim Reducers*/
const handleCreateClaimRequest = state1 => {
  return {
    ...state1,
    ...{
      createClaimPending: true,
      createClaimRes: null,
      createClaimError: null,
    },
  };
};
const handleCreateClaimSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      createClaimPending: false,
      createClaimRes: payload,
      createClaimError: null,
    },
  };
};
const handleCreateClaimError = (state1, payload) => ({
  ...state1,
  ...{
    createClaimPending: false,
    createClaimRes: null,
    createClaimError: payload,
  },
});


/*update Claim Reducers*/
const handleUpdateClaimRequest = state1 => {
  return {
    ...state1,
    ...{
      updateClaimPending: true,
      updateClaimRes: null,
      updateClaimError: null,
    },
  };
};
const handleUpdateClaimSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateClaimPending: false,
      updateClaimRes: payload,
      updateClaimError: null,
    },
  };
};
const handleUpdateClaimError = (state1, payload) => ({
  ...state1,
  ...{
    updateClaimPending: false,
    updateClaimRes: null,
    updateClaimError: payload,
  },
});

/*Delete Claim Reducers*/
const handleDeleteClaimRequest = state1 => {
  return {
    ...state1,
    ...{
      deleteClaimPending: true,
      deleteClaimRes: null,
      deleteClaimError: null,
    },
  };
};
const handleDeleteClaimSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      deleteClaimPending: false,
      deleteClaimRes: payload,
      deleteClaimError: null,
    },
  };
};
const handleDeleteClaimError = (state1, payload) => ({
  ...state1,
  ...{
    deleteClaimPending: false,
    deleteClaimRes: null,
    deleteClaimError: payload,
  },
});

/*Get Claim Reducers*/
const handleGetClaimRequest = state1 => {
  return {
    ...state1,
    ...{
      getClaimPending: true,
      getClaimRes: null,
      getClaimError: null,
    },
  };
};
const handleGetClaimSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getClaimPending: false,
      getClaimRes: payload,
      getClaimError: null,
    },
  };
};
const handleGetClaimError = (state1, payload) => ({
  ...state1,
  ...{
    getClaimPending: false,
    getClaimRes: null,
    getClaimError: payload,
  },
});

/*get Claim Approval Reducers*/
const handleGetClaimApprovalRequest = state1 => {
  return {
    ...state1,
    ...{
      getClaimApprovalPending: true,
      getClaimApprovalRes: null,
      getClaimApprovalError: null,
    },
  };
};
const handleGetClaimApprovalSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getClaimApprovalPending: false,
      getClaimApprovalRes: payload,
      getClaimApprovalError: null,
    },
  };
};
const handleGetClaimApprovalError = (state1, payload) => ({
  ...state1,
  ...{
    getClaimApprovalPending: false,
    getClaimApprovalRes: null,
    getClaimApprovalError: payload,
  },
});


/*approve Reject Claim Request Reducers*/
const handleApproveRejectClaimRequest = state1 => {
  return {
    ...state1,
    ...{
      approveRejectClaimPending: true,
      approveRejectClaimRes: null,
      approveRejectClaimError: null,
    },
  };
};
const handleApproveRejectClaimSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      approveRejectClaimPending: false,
      approveRejectClaimRes: payload,
      approveRejectClaimError: null,
    },
  };
};
const handleApproveRejectClaimError = (state1, payload) => ({
  ...state1,
  ...{
    approveRejectClaimPending: false,
    approveRejectClaimRes: null,
    approveRejectClaimError: payload,
  },
});

/* Get All Travel Approval Data Reducers*/
const handleGetAllTravelApprovalDataRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllTravelApprovalDataPending: true,
      getAllTravelApprovalDataRes: null,
      getAllTravelApprovalDataError: null,
    },
  };
};
const handleGetAllTravelApprovalDataSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllTravelApprovalDataPending: false,
      getAllTravelApprovalDataRes: payload,
      getAllTravelApprovalDataError: null,
    },
  };
};
const handleGetAllTravelApprovalDataError = (state1, payload) => ({
  ...state1,
  ...{
    getAllTravelApprovalDataPending: false,
    getAllTravelApprovalDataRes: null,
    getAllTravelApprovalDataError: payload,
  },
});

const handleSelectedTravelData = (state1, payload) => {
  return {
    selectedTravelData: payload,
  }

};

const handleSelectedTravelClaimDetail = (state1, payload) => {
  return {
    selectedTravelClaimDetail: payload,
  }

};





// Clear Existing Data Store Reducers*/
const clearTravelStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_CREATE_TRAVEL_APPLICATION_STORE':
      return {
        ...state,
        ...{
          createTravelApplicationPending: false,
          createTravelApplicationRes: null,
          createTravelApplicationError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_TRAVEL_REQUEST_STORE':
      return {
        ...state,
        ...{
          getTravelRequestPending: false,
          getTravelRequestRes: null,
          getTravelRequestError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_TRAVEL_STORE':
      return {
        ...state,
        ...{
          deleteTravelPending: false,
          deleteTravelRes: null,
          deleteTravelError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_TRAVEL_STORE':
      return {
        ...state,
        ...{
          updateTravelApplicationPending: false,
          updateTravelApplicationRes: null,
          updateTravelApplicationError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_TRAVEL_STORE':
      return {
        ...state,
        ...{
          updateTravelApplicationPending: false,
          updateTravelApplicationRes: null,
          updateTravelApplicationError: null,
        },
      };
    case 'HANDLE_CLEAR_ADD_TRAVEL_TYPE_STORE':
      return {
        ...state,
        ...{
          addTravelTypePending: false,
          addTravelTypeRes: null,
          addTravelTypeError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_TRAVEL_TYPE_STORE':
      return {
        ...state,
        ...{
          getTravelTypePending: false,
          getTravelTypeRes: null,
          getTravelTypeError: null,
        },
      };

    case 'HANDLE_CLEAR_UPDATE_TRAVEL_TYPE_STORE':
      return {
        ...state,
        ...{
          updateTravelTypePending: false,
          updateTravelTypeRes: null,
          updateTravelTypeError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_TRAVEL_TYPE_STORE':
      return {
        ...state,
        ...{
          deleteTravelTypePending: false,
          deleteTravelTypeRes: null,
          deleteTravelTypeError: null,
        },
      };
    case 'HANDLE_CLEAR_CREATE_TRAVEL_AND_CLAIM_RULE_STORE':
      return {
        ...state,
        ...{
          createTravelAndClaimRulePending: false,
          createTravelAndClaimRuleRes: null,
          createTravelAndClaimRuleError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_TRAVEL_AND_CLAIM_RULE_STORE':
      return {
        ...state,
        ...{
          updateTravelAndClaimRulePending: false,
          updateTravelAndClaimRuleRes: null,
          updateTravelAndClaimRuleError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_TRAVEL_AND_CLAIM_RULE_STORE':
      return {
        ...state,
        ...{
          deleteTravelAndClaimRulePending: false,
          deleteTravelAndClaimRuleRes: null,
          deleteTravelAndClaimRuleError: null,
        },
      };
    case 'HANDLE_CLEAR_ASSIGN_RULE_STORE':
      return {
        ...state,
        ...{
          assignRulePending: false,
          assignRuleRes: null,
          assignRuleError: null,
        },
      };
      case 'HANDLE_CLEAR_GET_TRAVEL_TYPE_BY_ID_STORE':
        return {
          ...state,
          ...{
            getTravelTypeByIdPending: false,
            getTravelTypeByIdRes: null,
            getTravelTypeByIdError: null,
          },
        };
    case 'HANDLE_CLEAR_TRAVEL_REQUEST_APPROVE_REJECT_PENDING_STORE':
      return {
        ...state,
        ...{
          travelRequestApproveRejectPending: false,
          travelRequestApproveRejectRes: null,
          travelRequestApproveRejectError: null,
        },
      };

    case 'HANDLE_CLEAR_CREATE_CLAIM_STORE':
      return {
        ...state,
        ...{
          createClaimPending: false,
          createClaimRes: null,
          createClaimError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_CLAIM_STORE':
      return {
        ...state,
        ...{
          updateClaimPending: false,
          updateClaimRes: null,
          updateClaimError: null,
        },
      };

    case 'HANDLE_CLEAR_DELETE_CLAIM_STORE':
      return {
        ...state,
        ...{
          deleteClaimPending: false,
          deleteClaimRes: null,
          deleteClaimError: null,
        },
      };


    case 'HANDLE_CLEAR_APPROVE_REJECT_CLAIM_STORE':
      return {
        ...state,
        ...{
          approveRejectClaimPending: false,
          approveRejectClaimRes: null,
          approveRejectClaimError: null,
        },
      };
      case 'HANDLE_CLEAR_SELECTED_TRAVEL_DATA_STORE':
        return {
          ...state,
          ...{
            selectedTravelData: null,
         
          },
        };
        case 'HANDLE_CLEAR_SELECTED_TRAVEL_CLAIM_Detail_STORE':
          return {
            ...state,
            ...{
              selectedTravelClaimDetail: null,
           
            },
          };
    default:
      return state;
  }
};



export default createReducer(
  {
    [actions.createTravelApplicationRequest]: handleCreateTravelApplicationRequest,
    [actions.createTravelApplicationSuccess]: handleCreateTravelApplicationSuccess,
    [actions.createTravelApplicationError]: handleCreateTravelApplicationError,

    [actions.getTravelRequestRequest]: handleGetTravelRequestRequest,
    [actions.getTravelRequestSuccess]: handleGetTravelRequestSuccess,
    [actions.getTravelRequestError]: handleGetTravelRequestError,

    [actions.getTravelApprovalRequest]: handleGetTravelApprovalRequest,
    [actions.getTravelApprovalSuccess]: handleGetTravelApprovalSuccess,
    [actions.getTravelApprovalError]: handleGetTravelApprovalError,

    [actions.updateTravelApplicationRequest]: handleUpdateTravelApplicationRequest,
    [actions.updateTravelApplicationSuccess]: handleUpdateTravelApplicationSuccess,
    [actions.updateTravelApplicationError]: handleUpdateTravelApplicationError,

    [actions.deleteTravelRequest]: handleDeleteTravelRequest,
    [actions.deleteTravelSuccess]: handleDeleteTravelSuccess,
    [actions.deleteTravelError]: handleDeleteTravelError,

    [actions.addTravelTypeRequest]: handleAddTravelTypeRequest,
    [actions.addTravelTypeSuccess]: handleAddTravelTypeSuccess,
    [actions.addTravelTypeError]: handleAddTravelTypeError,

    [actions.getTravelTypeRequest]: handleGetTravelTypeRequest,
    [actions.getTravelTypeSuccess]: handleGetTravelTypeSuccess,
    [actions.getTravelTypeError]: handleGetTravelTypeError,

    [actions.updateTravelTypeRequest]: handleUpdateTravelTypeRequest,
    [actions.updateTravelTypeSuccess]: handleUpdateTravelTypeSuccess,
    [actions.updateTravelTypeError]: handleUpdateTravelTypeError,

    [actions.deleteTravelTypeRequest]: handleDeleteTravelTypeRequest,
    [actions.deleteTravelTypeSuccess]: handleDeleteTravelTypeSuccess,
    [actions.deleteTravelTypeError]: handleDeleteTravelTypeError,

    [actions.getAllTravelTypeRequest]: handleGetAllTravelTypeRequest,
    [actions.getAllTravelTypeSuccess]: handleGetAllTravelTypeSuccess,
    [actions.getAllTravelTypeError]: handleGetAllTravelTypeError,

    [actions.travelRequestApproveRejectRequest]: handleTravelRequestApproveRejectRequest,
    [actions.travelRequestApproveRejectSuccess]: handleTravelRequestApproveRejectSuccess,
    [actions.travelRequestApproveRejectError]: handleTravelRequestApproveRejectError,

    [actions.createTravelAndClaimRuleRequest]: handleCreateTravelAndClaimRuleRequest,
    [actions.createTravelAndClaimRuleSuccess]: handleCreateTravelAndClaimRuleSuccess,
    [actions.createTravelAndClaimRuleError]: handleCreateTravelAndClaimRuleError,

    [actions.getTravelAndClaimRuleRequest]: handleGetTravelAndClaimRuleRequest,
    [actions.getTravelAndClaimRuleSuccess]: handleGetTravelAndClaimRuleSuccess,
    [actions.getTravelAndClaimRuleError]: handleGetTravelAndClaimRuleError,


    [actions.updateTravelAndClaimRuleRequest]: handleUpdateTravelAndClaimRuleRequest,
    [actions.updateTravelAndClaimRuleSuccess]: handleUpdateTravelAndClaimRuleSuccess,
    [actions.updateTravelAndClaimRuleError]: handleUpdateTravelAndClaimRuleError,

    [actions.deleteTravelAndClaimRuleRequest]: handleDeleteTravelAndClaimRuleRequest,
    [actions.deleteTravelAndClaimRuleSuccess]: handleDeleteTravelAndClaimRuleSuccess,
    [actions.deleteTravelAndClaimRuleError]: handleDeleteTravelAndClaimRuleError,

    [actions.getAllTravelAndClaimRuleRequest]: handleGetAllTravelAndClaimRuleRequest,
    [actions.getAllTravelAndClaimRuleSuccess]: handleGetAllTravelAndClaimRuleSuccess,
    [actions.getAllTravelAndClaimRuleError]: handleGetAllTravelAndClaimRuleError,

    
    [actions.assignRuleRequest]: handleAssignRuleRequest,
    [actions.assignRuleSuccess]: handleAssignRuleSuccess,
    [actions.assignRuleError]: handleAssignRuleError,
        
    [actions.getAssignRuleRequest]: handleGetAssignRuleRequest,
    [actions.getAssignRuleSuccess]: handleGetAssignRuleSuccess,
    [actions.getAssignRuleError]: handleGetAssignRuleError,

    [actions.getTravelTypeByIdRequest]: handleGetTravelTypeByIdRequest,
    [actions.getTravelTypeByIdSuccess]: handleGetTravelTypeByIdSuccess,
    [actions.getTravelTypeByIdError]: handleGetTravelTypeByIdError,
    
    [actions.createClaimRequest]: handleCreateClaimRequest,
    [actions.createClaimSuccess]: handleCreateClaimSuccess,
    [actions.createClaimError]: handleCreateClaimError,

    [actions.updateClaimRequest]: handleUpdateClaimRequest,
    [actions.updateClaimSuccess]: handleUpdateClaimSuccess,
    [actions.updateClaimError]: handleUpdateClaimError,

    [actions.deleteClaimRequest]: handleDeleteClaimRequest,
    [actions.deleteClaimSuccess]: handleDeleteClaimSuccess,
    [actions.deleteClaimError]: handleDeleteClaimError,

    [actions.getClaimRequest]: handleGetClaimRequest,
    [actions.getClaimSuccess]: handleGetClaimSuccess,
    [actions.getClaimError]: handleGetClaimError,

    [actions.getClaimApprovalRequest]: handleGetClaimApprovalRequest,
    [actions.getClaimApprovalSuccess]: handleGetClaimApprovalSuccess,
    [actions.getClaimApprovalError]: handleGetClaimApprovalError,

    [actions.approveRejectClaimRequest]: handleApproveRejectClaimRequest,
    [actions.approveRejectClaimSuccess]: handleApproveRejectClaimSuccess,
    [actions.approveRejectClaimError]: handleApproveRejectClaimError,
    
    [actions.getAllTravelApprovalDataRequest]: handleGetAllTravelApprovalDataRequest,
    [actions.getAllTravelApprovalDataSuccess]: handleGetAllTravelApprovalDataSuccess,
    [actions.getAllTravelApprovalDataError]: handleGetAllTravelApprovalDataError,

    [actions.selectedTravelData]: handleSelectedTravelData,
    [actions.selectedTravelClaimDetail]: handleSelectedTravelClaimDetail,


    [actions.handleClearTravelStore]: clearTravelStore,
  },
  initialState,
);